/**
 * Posição do pedido na fila da triagem: a hora em que ele chegou na coluna —
 * ou a hora em que foi adiado, quando foi passado para o fim da fila.
 *
 * Quem entra na coluna agora (vindo de PEDIDO FECHADO ou PEDIDO RECUPERADO)
 * carimba entrada_coluna_em = agora, então cai sempre ATRÁS de quem já estava
 * esperando: o pedido antigo é a prioridade. Quem foi adiado com justificativa
 * conta como se tivesse chegado na hora do adiamento — vai para o fim sem
 * voltar para o topo quando um pedido novo chega depois dele.
 *
 * Sem data nenhuma o pedido vai para o fim.
 */
export function posicaoNaFila(
  entradaColunaEm?: string | null,
  manterEm?: string | null,
): number {
  const marcos = [entradaColunaEm, manterEm]
    .map((d) => (d ? new Date(d).getTime() : NaN))
    .filter((t) => Number.isFinite(t));
  return marcos.length ? Math.max(...marcos) : Number.MAX_SAFE_INTEGER;
}
